import React from 'react'
import "./About.css"
function Abouts() {
  return (
  <div className='hero-img1'>
    <div className="heading">
        <h1>ABOUT</h1>
        <p className='animation3'>Im a friendly Front-End-Developer.</p>
    </div>
</div>
  )
}

export default Abouts